(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambassador-program-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.getElementById('shopify-section-{{ section.id }}');
    if (!section) return;

    const form = section.querySelector('#AmbassadorProgramForm');
    const applyCtas = section.querySelectorAll('.js-apply-cta');

    const track = function(eventName, extra) {
      const payload = Object.assign({ event: eventName, page: 'ambassador_program' }, extra || {});

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);

      document.dispatchEvent(new CustomEvent('8ight:analytics', { detail: payload }));
    };

    track('ambassador_view');

    applyCtas.forEach(function(link) {
      link.addEventListener('click', function() {
        track('ambassador_apply_start', { source: 'cta_click' });
      });
    });

    if (!form) return;

    const successState = form.querySelector('[data-success-state="true"]');
    if (successState) {
      track('ambassador_success');
      return;
    }

    const summary = form.querySelector('.ambassador-page__error-summary:not(.ambassador-page__error-summary--server)');
    const submitButton = form.querySelector('.ambassador-page__submit');
    const submitText = form.querySelector('.ambassador-page__submit-text');
    const submitLoading = form.querySelector('.ambassador-page__submit-loading');
    const bodyField = form.querySelector('.ambassador-page__hidden-body');

    const clearValidationState = function() {
      form.querySelectorAll('.is-invalid').forEach(function(node) {
        node.classList.remove('is-invalid');
      });

      form.querySelectorAll('[aria-invalid="true"]').forEach(function(node) {
        node.removeAttribute('aria-invalid');
      });

      if (summary) {
        summary.hidden = true;
        summary.innerHTML = '';
      }
    };

    const markInvalid = function(input, message, errors) {
      const field = input.closest('.ambassador-page__field, .ambassador-page__check, .ambassador-page__choice-group');
      if (field) {
        field.classList.add('is-invalid');
      }

      input.setAttribute('aria-invalid', 'true');
      errors.push(message);
    };

    const checkedValues = function(selector) {
      return Array.from(form.querySelectorAll(selector))
        .filter(function(input) { return input.checked; })
        .map(function(input) { return input.value; });
    };

    const buildApplicationPayload = function() {
      return {
        'Full name': form.querySelector('[name="contact[name]"]').value.trim(),
        'Email': form.querySelector('[name="contact[email]"]').value.trim(),
        'Country': form.querySelector('[name="contact[country]"]').value.trim(),
        'Profile type': checkedValues('input[name^="contact[profile_type_]"]').join(', '),
        'Audience size': form.querySelector('[name="contact[audience_size]"]').value.trim(),
        'Social or portfolio links': form.querySelector('[name="contact[social_links]"]').value.trim(),
        'Partnership interest': checkedValues('input[name^="contact[partnership_]"]').join(', '),
        'Motivation': form.querySelector('[name="contact[motivation]"]').value.trim(),
        'Consent': form.querySelector('[name="contact[consent]"]').checked ? 'Yes' : 'No'
      };
    };

    form.addEventListener('submit', function(event) {
      clearValidationState();

      const errors = [];
      const requiredFields = form.querySelectorAll('[required]');

      requiredFields.forEach(function(input) {
        if (input.type === 'checkbox') {
          if (!input.checked) {
            markInvalid(input, 'Please confirm consent before submitting.', errors);
          }
          return;
        }

        if (!input.value.trim()) {
          const label = input.getAttribute('data-label') || 'This field';
          markInvalid(input, label + ' is required.', errors);
        }
      });

      const email = form.querySelector('[name="contact[email]"]');
      if (email && email.value.trim()) {
        const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
        if (!emailOk) {
          markInvalid(email, 'Please enter a valid email address.', errors);
        }
      }

      const socialLinks = form.querySelector('[name="contact[social_links]"]');
      if (socialLinks && socialLinks.value.trim()) {
        const hasLinkLikeValue = /(https?:\/\/|www\.|instagram|tiktok|youtube|twitch|linkedin|x\.com|twitter|discord|community)/i.test(socialLinks.value);
        if (!hasLinkLikeValue) {
          markInvalid(socialLinks, 'Please include at least one social, portfolio, or community link.', errors);
        }
      }

      const profileTypeGroup = form.querySelector('[data-group-required="profile_type"]');
      const profileTypeInputs = form.querySelectorAll('input[name^="contact[profile_type_]"]');
      const profileTypeSelected = Array.from(profileTypeInputs).some(function(input) { return input.checked; });
      if (!profileTypeSelected && profileTypeGroup) {
        profileTypeGroup.classList.add('is-invalid');
        errors.push('Please select at least one profile type.');
      }

      const partnershipGroup = form.querySelector('[data-group-required="partnership_interest"]');
      const partnershipInputs = form.querySelectorAll('input[name^="contact[partnership_]"]');
      const partnershipSelected = Array.from(partnershipInputs).some(function(input) { return input.checked; });
      if (!partnershipSelected && partnershipGroup) {
        partnershipGroup.classList.add('is-invalid');
        errors.push('Please select at least one partnership interest.');
      }

      if (errors.length > 0) {
        event.preventDefault();
        track('ambassador_submit', { status: 'error' });
        track('ambassador_error');

        if (summary) {
          const uniqueErrors = Array.from(new Set(errors));
          summary.innerHTML = '<strong>Please review the form.</strong><ul>' + uniqueErrors.map(function(error) {
            return '<li>' + error + '</li>';
          }).join('') + '</ul>';
          summary.hidden = false;
          summary.focus();
        }

        const firstInvalid = form.querySelector('.is-invalid input, .is-invalid select, .is-invalid textarea');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      const payload = buildApplicationPayload();
      if (bodyField) {
        bodyField.value = Object.keys(payload).map(function(key) {
          return key + ': ' + payload[key];
        }).join('\n');
      }

      // TODO: replace this Shopify contact-form handoff with a direct CRM, waitlist, or ambassador-ops integration when available.
      console.log('8ight Ambassador Program application payload', payload);
      track('ambassador_submit', { status: 'success_pending' });

      if (submitButton && submitText && submitLoading) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        submitText.hidden = true;
        submitLoading.hidden = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function() {
    const blogGrid = document.getElementById('blog-grid');
    const loadingIndicator = document.getElementById('blog-loading');
    const moreIndicator = document.getElementById('blog-more-indicator');
    
    if (!blogGrid) return;

    let currentPage = parseInt(blogGrid.dataset.page) || 1;
    let totalPages = parseInt(blogGrid.dataset.totalPages) || 1;
    let articlesOnPage = parseInt(blogGrid.dataset.articlesOnPage) || 0;
    let isLoading = false;
    let hiddenArticles = blogGrid.querySelectorAll('.article-card--hidden');
    let hasMoreArticles = hiddenArticles.length > 0 || currentPage < totalPages;

    // Show/hide "more articles" indicator
    function updateMoreIndicator() {
      if (moreIndicator) {
        if (hasMoreArticles && !isLoading) {
          moreIndicator.style.display = 'block';
        } else {
          moreIndicator.style.display = 'none';
        }
      }
    }

    // Check if we're near the bottom of the page
    function checkScroll() {
      if (isLoading || !hasMoreArticles) {
        updateMoreIndicator();
        return;
      }

      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      const threshold = 500; // Load when 500px from bottom

      if (scrollPosition >= pageHeight - threshold) {
        loadMoreArticles();
      }
    }

    // Load more articles - first reveal hidden ones, then fetch from next pages
    async function loadMoreArticles() {
      if (isLoading || !hasMoreArticles) return;

      isLoading = true;
      if (loadingIndicator) {
        loadingIndicator.style.display = 'flex';
      }
      if (moreIndicator) {
        moreIndicator.style.display = 'none';
      }

      try {
        // First, reveal hidden articles from current page
        hiddenArticles = blogGrid.querySelectorAll('.article-card--hidden');
        if (hiddenArticles.length > 0) {
          // Show hidden articles
          hiddenArticles.forEach(article => {
            article.classList.remove('article-card--hidden');
          });
          
          // Update state
          hiddenArticles = blogGrid.querySelectorAll('.article-card--hidden');
          hasMoreArticles = hiddenArticles.length > 0 || currentPage < totalPages;
        } else if (currentPage < totalPages) {
          // Load from next page
          const nextPage = currentPage + 1;
          const blogUrl = window.location.pathname;
          const url = `${blogUrl}?page=${nextPage}`;

          const response = await fetch(url);
          const html = await response.text();
          
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Find articles in the response (all of them, including hidden)
          const newArticles = doc.querySelectorAll('#blog-grid .article-card');
          
          if (newArticles.length > 0) {
            // Append new articles to the grid (show all of them)
            newArticles.forEach(article => {
              const clonedArticle = article.cloneNode(true);
              // Remove hidden class so they show immediately
              clonedArticle.classList.remove('article-card--hidden');
              blogGrid.appendChild(clonedArticle);
            });

            // Update page counter
            currentPage = nextPage;
            blogGrid.dataset.page = currentPage;
            
            // Check if there are more pages
            const responseGrid = doc.getElementById('blog-grid');
            if (responseGrid) {
              const newTotalPages = parseInt(responseGrid.dataset.totalPages) || totalPages;
              totalPages = newTotalPages;
              blogGrid.dataset.totalPages = totalPages;
            }
            
            hasMoreArticles = currentPage < totalPages;
          } else {
            hasMoreArticles = false;
          }
        } else {
          hasMoreArticles = false;
        }
      } catch (error) {
        console.error('Error loading more articles:', error);
        hasMoreArticles = false;
      } finally {
        isLoading = false;
        if (loadingIndicator) {
          loadingIndicator.style.display = 'none';
        }
        updateMoreIndicator();
      }
    }

    // Throttle scroll events
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(checkScroll, 100);
    }, { passive: true });

    // Initial check
    setTimeout(function() {
      checkScroll();
      updateMoreIndicator();
    }, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eight-stories-journal"]) return;
  try {
    
  document.querySelectorAll('.eight-stories__lead-video video').forEach((video) => {
    const pauseAfterIntro = () => {
      window.setTimeout(() => {
        video.pause();
      }, 4800);
    };

    if (video.paused) {
      video.addEventListener('playing', pauseAfterIntro, { once: true });
    } else {
      pauseAfterIntro();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFooterLogoAnimations = (root = document) => {
      const logos = root.querySelectorAll('.eight-footer-signature:not([data-eight-footer-ready])');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      logos.forEach((logo) => {
        logo.setAttribute('data-eight-footer-ready', 'true');

        if (prefersReducedMotion) {
          logo.setAttribute('data-eight-footer-state', 'complete');
          return;
        }

        logo.setAttribute('data-eight-footer-state', 'pending');

        const play = () => {
          logo.setAttribute('data-eight-footer-state', 'playing');
          window.setTimeout(() => {
            logo.setAttribute('data-eight-footer-state', 'complete');
          }, 1500);
        };

        if (!('IntersectionObserver' in window)) {
          play();
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          window.requestAnimationFrame(play);
        }, { threshold: 0.35 });

        observer.observe(logo);
      });
    };

    const initNewsletterForms = (root = document) => {
      root.querySelectorAll('.footer__newsletter-form:not([data-newsletter-ready])').forEach((form) => {
        form.setAttribute('data-newsletter-ready', 'true');

        const input = form.querySelector('.footer__newsletter-input');
        const button = form.querySelector('.footer__newsletter-button');
        const status = form.querySelector('[data-newsletter-status]');

        if (!input || !button || !status || status.dataset.serverState) return;

        let touched = false;

        const showStatus = (message, state = 'neutral') => {
          status.textContent = message;
          status.hidden = false;
          status.classList.toggle('footer__newsletter-status--success', state === 'success');
          status.classList.toggle('footer__newsletter-status--error', state === 'error');

          if (state === 'error') input.setAttribute('aria-invalid', 'true');
          else input.removeAttribute('aria-invalid');
        };

        const validate = () => {
          const value = input.value.trim();

          if (!value) {
            showStatus('Enter your email address.', 'error');
            return false;
          }

          if (!input.validity.valid) {
            showStatus('Enter a valid email, like name@example.com.', 'error');
            return false;
          }

          showStatus('Email looks good.', 'success');
          return true;
        };

        input.addEventListener('blur', () => {
          touched = true;
          if (input.value.trim()) validate();
        });

        input.addEventListener('input', () => {
          if (!touched) return;
          if (!input.value.trim()) {
            status.hidden = true;
            input.removeAttribute('aria-invalid');
            return;
          }
          validate();
        });

        input.addEventListener('invalid', () => {
          touched = true;
          validate();
        });

        const submitNewsletter = async () => {
          if (button.disabled) return;

          touched = true;
          if (!validate()) {
            input.focus();
            return;
          }

          showStatus('Submitting your email...', 'neutral');
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch(form.action, {
              method: 'POST',
              body: new FormData(form),
              credentials: 'same-origin',
              headers: {
                Accept: 'text/html',
                'X-Requested-With': 'XMLHttpRequest',
              },
            });
            const responseHtml = await response.text();
            const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
            const responseStatus = responseDocument.querySelector('[data-newsletter-status][data-server-state]');
            const responseError = responseDocument.querySelector('.footer__newsletter-form .errors, form#contact_form .errors');
            const postedSuccessfully = response.url.includes('customer_posted=true') || responseStatus?.dataset.serverState === 'success';

            if (!response.ok || !postedSuccessfully) {
              const message = responseError?.textContent.trim() || 'We could not subscribe that email right now. Please try again.';
              throw new Error(message);
            }

            input.value = '';
            touched = false;
            showStatus("You're subscribed. We'll keep you updated.", 'success');
          } catch (error) {
            showStatus(error.message || 'We could not subscribe that email right now. Please try again.', 'error');
          } finally {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        };

        button.addEventListener('click', submitNewsletter);

        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || event.isComposing) return;
          event.preventDefault();
          submitNewsletter();
        });

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          submitNewsletter();
        }, true);
      });
    };

    initFooterLogoAnimations();
    initNewsletterForms();
    document.addEventListener('shopify:section:load', (event) => {
      initFooterLogoAnimations(event.target);
      initNewsletterForms(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const toggle = header.querySelector('.site-header__toggle');
    const close = header.querySelector('.site-header__close');
    const backdrop = header.querySelector('.site-header__backdrop');
    const menu = header.querySelector('.site-header__menu');
    const menuShell = header.querySelector('.site-header__menu-shell');
    const menuTitle = header.querySelector('.site-header__menu-title--mobile');
    const menuScroll = header.querySelector('[data-mobile-menu-scroll]');
    const menuList = header.querySelector('.site-header__list');
    const focusGate = header.querySelector('[data-mobile-focus-gate]');
    const headerInner = header.querySelector('.site-header__inner');
    const mobileHeaderChrome = headerInner ? [...headerInner.children].filter((element) => element !== menu) : [];
    const mobileHeaderChromeState = new Map(mobileHeaderChrome.map((element) => [element, {
      inert: element.inert,
      ariaHidden: element.getAttribute('aria-hidden'),
    }]));
    const submenuItems = [...header.querySelectorAll('.site-header__item--has-children')];
    const sunglassesToggle = header.querySelector('[data-sunglasses-toggle]');
    const mobileMenuQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopHoverQuery = window.matchMedia('(min-width: 1120px) and (hover: hover) and (pointer: fine)');
    const hoverCloseTimers = new WeakMap();
    let mobileMode = mobileMenuQuery.matches;
    let highlightedItem = null;
    let bodyLockState = null;
    let tabletOverflowState = null;
    let outsideInertState = [];

    const itemLabel = (item) => item.querySelector(':scope > .site-header__link .site-header__link-main')?.textContent.trim() || 'menu';

    const placeMobileGate = (item = highlightedItem) => {
      if (!mobileMode || !focusGate || !menuList || !item) return;
      highlightedItem = item;
      const top = menuList.offsetTop + item.offsetTop;
      focusGate.style.setProperty('--gate-y', `${top}px`);
      focusGate.style.setProperty('--gate-height', `${item.offsetHeight}px`);
    };

    const revealMobileItem = (item) => {
      if (!mobileMode || !menuScroll || !menuList || !item) return;
      const padding = 8;
      const top = menuList.offsetTop + item.offsetTop;
      const bottom = top + item.offsetHeight;
      const visibleTop = menuScroll.scrollTop + padding;
      const visibleBottom = menuScroll.scrollTop + menuScroll.clientHeight - padding;
      let nextTop = menuScroll.scrollTop;

      if (bottom > visibleBottom) nextTop = bottom - menuScroll.clientHeight + padding;
      else if (top < visibleTop) nextTop = Math.max(0, top - padding);
      if (Math.abs(nextTop - menuScroll.scrollTop) < 1) return;
      menuScroll.scrollTo({ top: nextTop, behavior: reducedMotionQuery.matches ? 'auto' : 'smooth' });
    };

    const setSubmenuOpen = (item, open) => {
      if (!item) return;
      const link = item.querySelector(':scope > .site-header__link');
      const disclosure = item.querySelector(':scope > [data-mobile-disclosure]');
      const submenu = item.querySelector(':scope > .site-header__submenu');
      item.classList.toggle('is-open', open);

      if (mobileMode) {
        if (disclosure) {
          disclosure.setAttribute('aria-expanded', open ? 'true' : 'false');
          disclosure.setAttribute('aria-label', `${open ? 'Hide' : 'Show'} ${itemLabel(item)} links`);
        }
        if (submenu) {
          submenu.inert = !open;
          submenu.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
      } else if (link) {
        link.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      if (mobileMode) {
        placeMobileGate(item);
        if (open) window.requestAnimationFrame(() => revealMobileItem(item));
      }
    };

    const closeSubmenus = (exceptItem = null) => {
      submenuItems.forEach((item) => {
        if (item !== exceptItem) setSubmenuOpen(item, false);
      });
    };

    const clearHoverClose = (item) => {
      const timer = hoverCloseTimers.get(item);
      if (!timer) return;
      window.clearTimeout(timer);
      hoverCloseTimers.delete(item);
    };

    const scheduleHoverClose = (item) => {
      clearHoverClose(item);
      const timer = window.setTimeout(() => {
        hoverCloseTimers.delete(item);
        if (item.matches(':hover') || item.contains(document.activeElement)) return;
        setSubmenuOpen(item, false);
      }, 140);
      hoverCloseTimers.set(item, timer);
    };

    const lockBody = () => {
      if (bodyLockState) return;
      const body = document.body;
      const root = document.documentElement;
      bodyLockState = {
        scrollY: window.scrollY,
        body: {
          position: body.style.position,
          top: body.style.top,
          left: body.style.left,
          right: body.style.right,
          width: body.style.width,
          overflow: body.style.overflow,
        },
        rootOverflow: root.style.overflow,
      };
      body.style.position = 'fixed';
      body.style.top = `-${bodyLockState.scrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      root.style.overflow = 'hidden';
    };

    const unlockBody = () => {
      if (!bodyLockState) return;
      const state = bodyLockState;
      bodyLockState = null;
      Object.assign(document.body.style, state.body);
      document.documentElement.style.overflow = state.rootOverflow;
      window.scrollTo(0, state.scrollY);
    };

    const lockTabletBody = () => {
      if (tabletOverflowState !== null) return;
      tabletOverflowState = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    };

    const unlockTabletBody = () => {
      if (tabletOverflowState === null) return;
      document.body.style.overflow = tabletOverflowState;
      tabletOverflowState = null;
    };

    const setOutsideInert = (inert) => {
      if (inert) {
        if (outsideInertState.length) return;
        outsideInertState = [...document.body.children]
          .filter((element) => element instanceof HTMLElement && !element.contains(header))
          .map((element) => [element, element.inert]);
        outsideInertState.forEach(([element]) => { element.inert = true; });
        return;
      }

      outsideInertState.forEach(([element, wasInert]) => { element.inert = wasInert; });
      outsideInertState = [];
    };

    const mobileFocusable = () => [...menu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.closest('[hidden], [inert]') && element.offsetParent !== null);

    const setMobileHeaderChromeInert = (inert) => {
      mobileHeaderChrome.forEach((element) => {
        const initial = mobileHeaderChromeState.get(element);
        if (inert) {
          element.inert = true;
          element.setAttribute('aria-hidden', 'true');
          return;
        }

        element.inert = initial?.inert || false;
        if (initial?.ariaHidden === null || initial?.ariaHidden === undefined) element.removeAttribute('aria-hidden');
        else element.setAttribute('aria-hidden', initial.ariaHidden);
      });
    };

    const setMobileDialog = (open) => {
      if (!menu || !menuShell) return;
      menu.inert = !open;
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      setMobileHeaderChromeInert(open);
      menuShell.setAttribute('role', 'dialog');
      menuShell.setAttribute('aria-modal', 'true');
      if (menuTitle?.id) menuShell.setAttribute('aria-labelledby', menuTitle.id);
    };

    const clearMobileDialog = () => {
      if (!menu || !menuShell) return;
      menu.inert = false;
      menu.removeAttribute('aria-hidden');
      setMobileHeaderChromeInert(false);
      menuShell.removeAttribute('role');
      menuShell.removeAttribute('aria-modal');
      menuShell.removeAttribute('aria-labelledby');
    };

    const syncDisclosureMode = () => {
      submenuItems.forEach((item) => {
        const link = item.querySelector(':scope > .site-header__link');
        const disclosure = item.querySelector(':scope > [data-mobile-disclosure]');
        const submenu = item.querySelector(':scope > .site-header__submenu');
        if (!link || !disclosure || !submenu) return;
        const controls = disclosure.getAttribute('aria-controls');

        if (mobileMode) {
          const isOpen = item.classList.contains('is-open');
          disclosure.hidden = false;
          disclosure.inert = false;
          disclosure.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          disclosure.setAttribute('aria-label', `${isOpen ? 'Hide' : 'Show'} ${itemLabel(item)} links`);
          link.removeAttribute('aria-haspopup');
          link.removeAttribute('aria-expanded');
          link.removeAttribute('aria-controls');
          submenu.inert = !isOpen;
          submenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        } else {
          disclosure.hidden = true;
          disclosure.inert = true;
          link.setAttribute('aria-haspopup', 'true');
          link.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
          if (controls) link.setAttribute('aria-controls', controls);
          submenu.inert = false;
          submenu.removeAttribute('aria-hidden');
        }
      });
    };

    const setOpen = (open, { restoreFocus = true } = {}) => {
      header.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open) {
        if (mobileMode) {
          lockBody();
          setMobileDialog(true);
          setOutsideInert(true);
          const currentParent = header.querySelector('.site-header__item[data-current-ancestor="true"]');
          if (currentParent) {
            closeSubmenus(currentParent);
            setSubmenuOpen(currentParent, true);
          }
          window.requestAnimationFrame(() => {
            const currentItem = currentParent || header.querySelector('.site-header__item[data-current="true"]') || header.querySelector('.site-header__item');
            highlightedItem = currentItem;
            placeMobileGate(currentItem);
            header.classList.add('is-mobile-menu-ready');
            (close || menuTitle)?.focus();
          });
        } else {
          lockTabletBody();
        }
        return;
      }

      header.classList.remove('is-mobile-menu-ready');
      closeSubmenus();
      if (mobileMode) {
        setMobileDialog(false);
        setOutsideInert(false);
        unlockBody();
      } else {
        unlockTabletBody();
      }
      if (restoreFocus && mobileMode && toggle && document.contains(toggle)) toggle.focus();
    };

    const syncResponsiveMode = () => {
      const nextMobileMode = mobileMenuQuery.matches;
      if (nextMobileMode !== mobileMode && header.classList.contains('is-open')) {
        setOpen(false, { restoreFocus: false });
      }
      mobileMode = nextMobileMode;
      syncDisclosureMode();

      if (mobileMode) {
        setMobileDialog(header.classList.contains('is-open'));
        if (!header.classList.contains('is-open')) setOutsideInert(false);
      } else {
        clearMobileDialog();
        setOutsideInert(false);
        if (!header.classList.contains('is-open')) {
          unlockBody();
          unlockTabletBody();
        }
        header.classList.remove('is-mobile-menu-ready');
      }
    };

    if (toggle) toggle.addEventListener('click', () => setOpen(true));
    if (close) close.addEventListener('click', () => setOpen(false));
    if (backdrop) backdrop.addEventListener('click', () => setOpen(false));

    if (sunglassesToggle && !document.querySelector('[data-home-approved-v4]')) {
      sunglassesToggle.addEventListener('click', () => {
        const isPressed = sunglassesToggle.getAttribute('aria-pressed') === 'true';
        sunglassesToggle.setAttribute('aria-pressed', isPressed ? 'false' : 'true');
      });
    }

    document.addEventListener('click', (event) => {
      if (header.contains(event.target)) return;
      closeSubmenus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (header.classList.contains('is-open')) {
          event.preventDefault();
          setOpen(false);
        } else {
          closeSubmenus();
        }
        return;
      }

      if (!mobileMode || !header.classList.contains('is-open') || event.key !== 'Tab') return;
      const focusable = mobileFocusable();
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    submenuItems.forEach((item) => {
      const link = item.querySelector(':scope > .site-header__link');
      const disclosure = item.querySelector(':scope > [data-mobile-disclosure]');
      if (!link) return;

      item.addEventListener('pointerenter', () => {
        if (mobileMode) {
          placeMobileGate(item);
          return;
        }
        if (!desktopHoverQuery.matches) return;
        clearHoverClose(item);
        closeSubmenus(item);
        setSubmenuOpen(item, true);
      });

      item.addEventListener('pointerleave', () => {
        if (!desktopHoverQuery.matches) return;
        scheduleHoverClose(item);
      });

      item.addEventListener('focusin', () => {
        if (mobileMode) {
          placeMobileGate(item);
          return;
        }
        if (window.innerWidth < 1120) return;
        clearHoverClose(item);
        closeSubmenus(item);
        setSubmenuOpen(item, true);
      });

      item.addEventListener('focusout', () => {
        if (window.innerWidth < 1120) return;
        window.setTimeout(() => {
          if (!item.contains(document.activeElement)) scheduleHoverClose(item);
        }, 0);
      });

      link.addEventListener('click', (event) => {
        if (mobileMode) {
          const href = link.getAttribute('href') || '';
          if (href === '#' || href === '') {
            event.preventDefault();
            const shouldOpen = !item.classList.contains('is-open');
            closeSubmenus(item);
            setSubmenuOpen(item, shouldOpen);
          } else {
            setOpen(false, { restoreFocus: false });
          }
          return;
        }

        event.preventDefault();
        const shouldOpen = !item.classList.contains('is-open');
        closeSubmenus(item);
        setSubmenuOpen(item, shouldOpen);
      });

      if (disclosure) {
        disclosure.addEventListener('click', () => {
          if (!mobileMode) return;
          const shouldOpen = !item.classList.contains('is-open');
          closeSubmenus(item);
          setSubmenuOpen(item, shouldOpen);
        });
      }

      item.addEventListener('click', (event) => {
        if (!event.target.closest('.site-header__sublink')) return;
        closeSubmenus();
        if (window.innerWidth < 1120) setOpen(false, { restoreFocus: false });
      });
    });

    header.querySelectorAll('.site-header__item:not(.site-header__item--has-children) > .site-header__link').forEach((link) => {
      link.addEventListener('click', () => {
        if (mobileMode) setOpen(false, { restoreFocus: false });
      });
      const item = link.closest('.site-header__item');
      item?.addEventListener('pointerenter', () => placeMobileGate(item));
      item?.addEventListener('focusin', () => placeMobileGate(item));
    });

    menuList?.addEventListener('pointerleave', () => {
      if (!mobileMode) return;
      const fallback = header.querySelector('.site-header__item.is-open, .site-header__item[data-current="true"], .site-header__item[data-current-ancestor="true"]');
      placeMobileGate(fallback);
    });

    const gateObserver = typeof ResizeObserver === 'function' && menuList
      ? new ResizeObserver(() => placeMobileGate())
      : null;
    if (gateObserver) gateObserver.observe(menuList);

    const handleResponsiveChange = () => syncResponsiveMode();
    if (typeof mobileMenuQuery.addEventListener === 'function') mobileMenuQuery.addEventListener('change', handleResponsiveChange);
    else mobileMenuQuery.addListener(handleResponsiveChange);

    window.addEventListener('resize', () => {
      syncResponsiveMode();
      if (window.innerWidth >= 1120) {
        setOpen(false, { restoreFocus: false });
        closeSubmenus();
      } else {
        placeMobileGate();
      }
    });

    syncResponsiveMode();

    const emitAnalytics = (eventName, detail = {}) => {
      const payload = {
        event: eventName,
        page_path: window.location.pathname,
        page_title: document.title,
        ...detail,
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('8ight:analytics', { detail: payload }));
    };

    const classifyLink = (href, label) => {
      const normalizedHref = href.toLowerCase();
      const normalizedLabel = label.toLowerCase();

      if (normalizedHref.includes('/pages/waitlist') || normalizedLabel.includes('waitlist')) return 'waitlist_click';
      if (normalizedHref.includes('kickstarter') || normalizedLabel.includes('kickstarter')) return 'kickstarter_click';
      if (normalizedHref.includes('/pages/product-introduction') || normalizedHref.includes('/pages/8ight-pro') || normalizedHref.includes('/products/8ight-pro')) return 'product_click';
      if (normalizedHref.includes('/pages/specs') || normalizedHref.includes('/pages/size-fit')) return 'product_detail_click';
      if (normalizedHref.includes('/pages/responsible-use') || normalizedHref.includes('/pages/pre-order-terms')) return 'trust_click';
      if (normalizedHref.includes('/blogs/stories')) return 'stories_click';
      if (normalizedHref.includes('linkedin.com') || normalizedHref.includes('discord.gg') || normalizedHref.includes('x.com')) return 'social_click';
      return 'site_link_click';
    };

    document.addEventListener('click', (event) => {
      const interactive = event.target.closest('a[href], button[type="submit"], summary');
      if (!interactive) return;

      if (interactive.matches('a[href]')) {
        const label = interactive.textContent.trim();
        const href = interactive.getAttribute('href') || '';
        emitAnalytics(classifyLink(href, label), {
          link_text: label,
          link_url: href,
        });
        return;
      }

      if (interactive.matches('button[type="submit"]')) {
        const form = interactive.closest('form');
        const formClass = form ? form.className : '';
        let formType = 'form_submit_click';
        if (formClass.includes('waitlist')) formType = 'waitlist_submit_click';
        if (formClass.includes('newsletter')) formType = 'newsletter_submit_click';
        emitAnalytics(formType, {
          button_text: interactive.textContent.trim(),
        });
        return;
      }

      if (interactive.matches('summary')) {
        const details = interactive.closest('details');
        if (!details) return;
        window.requestAnimationFrame(() => {
          if (!details.open) return;
          emitAnalytics('faq_open', {
            question: interactive.textContent.trim(),
          });
        });
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || !form.matches('form')) return;

      const formClass = form.className || '';
      let formType = 'form_submit';
      if (formClass.includes('waitlist')) formType = 'waitlist_submit';
      if (formClass.includes('newsletter')) formType = 'newsletter_submit';
      if (formClass.includes('contact')) formType = 'contact_submit';

      emitAnalytics(formType, {
        form_id: form.id || '',
      });
    });

    const bindModelAnalytics = (root = document) => {
      root.querySelectorAll('model-viewer').forEach((model) => {
        if (model.dataset.analyticsBound === 'true') return;
        model.dataset.analyticsBound = 'true';

        model.addEventListener('load', () => {
          emitAnalytics('model_viewer_loaded', {
            model_src: model.getAttribute('src') || '',
          });
        }, { once: true });

        model.addEventListener('camera-change', () => {
          emitAnalytics('model_viewer_interaction', {
            model_src: model.getAttribute('src') || '',
          });
        }, { once: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindModelAnalytics());
    } else {
      bindModelAnalytics();
    }

    document.addEventListener('shopify:section:load', (event) => bindModelAnalytics(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-pro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-home-launch-v3]');
    if (!root) return;

    const model = root.querySelector('model-viewer');
    const viewButtons = root.querySelectorAll('[data-view-orbit]');
    const spinToggle = root.querySelector('[data-spin-toggle]');
    if (model) model.removeAttribute('auto-rotate');

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const orbit = button.getAttribute('data-view-orbit');
        if (model && orbit) model.setAttribute('camera-orbit', orbit);
        viewButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
      });
    });

    if (spinToggle && model) {
      spinToggle.addEventListener('click', () => {
        const shouldSpin = !model.hasAttribute('auto-rotate');
        model.toggleAttribute('auto-rotate', shouldSpin);
        spinToggle.classList.toggle('is-active', shouldSpin);
        spinToggle.setAttribute('aria-pressed', shouldSpin ? 'true' : 'false');
        spinToggle.textContent = shouldSpin ? 'Stop spin' : 'Spin';
      });
    }

    const tabButtons = root.querySelectorAll('[data-tab-trigger]');
    const tabPanels = root.querySelectorAll('[data-tab-panel]');
    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.getAttribute('data-tab-trigger');
        tabButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach((panel) => {
          const isActive = panel.getAttribute('data-tab-panel') === key;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
      });
    });

    const search = root.querySelector('[data-faq-search]');
    const faqItems = root.querySelectorAll('[data-faq-item]');
    if (search) {
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        faqItems.forEach((item) => {
          const matches = item.textContent.toLowerCase().includes(query);
          item.classList.toggle('is-hidden', query.length > 0 && !matches);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-launch-approved-v4"] && !Shopify.designMode) return;
  try {
    
  function initApprovedHomeV4() {
    document.querySelectorAll('[data-home-approved-v4]').forEach(function(root) {
      if (root.dataset.approvedHomeReady === 'true') return;
      root.dataset.approvedHomeReady = 'true';

      root.dataset.lensMode = 'clear';

      var heroLensMedia = root.querySelectorAll('[data-lens-media]');
      var sunglassesToggle = document.querySelector('[data-sunglasses-toggle], .site-header__sunglasses-toggle');
      var lensRequestToken = 0;

      function setHeroLensMode(mode) {
        var nextMode = mode === 'sunglasses' ? 'sunglasses' : 'clear';
        root.dataset.lensMode = nextMode;
        heroLensMedia.forEach(function(media) {
          var isActive = media.getAttribute('data-lens-media') === nextMode;
          media.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (isActive) {
            media.setAttribute(
              'alt',
              nextMode === 'sunglasses'
                ? 'Person wearing 8ight Pro smart glasses with dark sunglasses lenses'
                : 'Person wearing 8ight Pro smart glasses with clear lenses'
            );
          } else {
            media.setAttribute('alt', '');
          }
        });
        if (sunglassesToggle) {
          sunglassesToggle.setAttribute('aria-pressed', nextMode === 'sunglasses' ? 'true' : 'false');
          sunglassesToggle.setAttribute(
            'aria-label',
            nextMode === 'sunglasses' ? 'Show clear lenses' : 'Show sunglasses lenses'
          );
        }
      }

      function requestHeroLensMode(mode) {
        var nextMode = mode === 'sunglasses' ? 'sunglasses' : 'clear';
        var targetMedia = root.querySelector('[data-lens-media="' + nextMode + '"]');
        var requestToken = ++lensRequestToken;

        if (!targetMedia || (targetMedia.complete && targetMedia.naturalWidth > 0)) {
          setHeroLensMode(nextMode);
          return;
        }

        if (sunglassesToggle) {
          sunglassesToggle.disabled = true;
          sunglassesToggle.setAttribute('aria-busy', 'true');
        }

        function finishLensRequest(success) {
          if (requestToken !== lensRequestToken) return;
          if (sunglassesToggle) {
            sunglassesToggle.disabled = false;
            sunglassesToggle.removeAttribute('aria-busy');
          }
          if (success) setHeroLensMode(nextMode);
        }

        if (typeof targetMedia.decode === 'function') {
          targetMedia.decode().then(function() {
            finishLensRequest(true);
          }).catch(function() {
            finishLensRequest(targetMedia.complete && targetMedia.naturalWidth > 0);
          });
          return;
        }

        targetMedia.addEventListener('load', function() {
          finishLensRequest(true);
        }, { once: true });
        targetMedia.addEventListener('error', function() {
          finishLensRequest(false);
        }, { once: true });
      }

      setHeroLensMode('clear');

      function enableLensCrossfade() {
        root.classList.add('is-lens-crossfade-ready');
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        enableLensCrossfade();
      } else {
        var heroFocusMedia = root.querySelector('[data-lens-media="clear"]');
        var lensCrossfadeTimer = window.setTimeout(enableLensCrossfade, 1800);
        if (heroFocusMedia) {
          heroFocusMedia.addEventListener('animationend', function() {
            window.clearTimeout(lensCrossfadeTimer);
            enableLensCrossfade();
          }, { once: true });
        }
      }

      if (sunglassesToggle) {
        sunglassesToggle.addEventListener('click', function() {
          var nextLensMode = root.dataset.lensMode === 'clear' ? 'sunglasses' : 'clear';
          if (!root.classList.contains('is-lens-crossfade-ready')) {
            enableLensCrossfade();
            window.requestAnimationFrame(function() {
              requestHeroLensMode(nextLensMode);
            });
            return;
          }
          requestHeroLensMode(nextLensMode);
        });
      }

      var search = root.querySelector('[data-faq-search]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
      var empty = root.querySelector('[data-faq-empty]');
      var filmVideo = root.querySelector('.home-approved-v4__documentary-video');
      var filmPlayer = root.querySelector('[data-film-player]');
      var filmPlayerVideo = filmPlayer ? filmPlayer.querySelector('video') : null;
      var filmOpeners = Array.prototype.slice.call(root.querySelectorAll('[data-film-reveal-trigger]'));
      var filmReset = filmPlayer ? filmPlayer.querySelector('[data-film-reset]') : null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var previousFilmFocus = null;
      var previousBodyOverflow = '';

      if (filmVideo && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        filmVideo.autoplay = false;
        filmVideo.removeAttribute('autoplay');
        filmVideo.pause();
      }

      function revealFilm(event) {
        if (!filmPlayer || !filmPlayerVideo) return;
        event.preventDefault();
        previousFilmFocus = document.activeElement;
        previousBodyOverflow = document.body ? document.body.style.overflow : '';
        if (document.body) document.body.style.overflow = 'hidden';
        filmPlayer.setAttribute('aria-hidden', 'false');
        filmPlayerVideo.setAttribute('tabindex', '0');
        filmOpeners.forEach(function(opener) {
          opener.setAttribute('aria-expanded', 'true');
        });
        if (filmReset) filmReset.focus({ preventScroll: true });
        if (!reducedMotion) {
          var playRequest = filmPlayerVideo.play();
          if (playRequest && typeof playRequest.catch === 'function') {
            playRequest.catch(function() {});
          }
        }
      }

      function resetFilm() {
        if (!filmPlayer || !filmPlayerVideo) return;
        filmPlayer.setAttribute('aria-hidden', 'true');
        filmPlayerVideo.setAttribute('tabindex', '-1');
        filmPlayerVideo.pause();
        filmPlayerVideo.currentTime = 0;
        filmOpeners.forEach(function(opener) {
          opener.setAttribute('aria-expanded', 'false');
        });
        if (document.body) document.body.style.overflow = previousBodyOverflow;
        if (previousFilmFocus && typeof previousFilmFocus.focus === 'function') {
          previousFilmFocus.focus({ preventScroll: true });
        } else if (filmOpeners[0]) {
          filmOpeners[0].focus({ preventScroll: true });
        }
        previousFilmFocus = null;
      }

      function handleFilmKeydown(event) {
        if (!filmPlayer || filmPlayer.getAttribute('aria-hidden') !== 'false') return;
        if (event.key === 'Escape') {
          event.preventDefault();
          resetFilm();
          return;
        }
        if (event.key !== 'Tab') return;
        var focusables = [filmReset, filmPlayerVideo].filter(function(element) {
          return element && !element.disabled;
        });
        if (focusables.length < 2) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      filmOpeners.forEach(function(opener) {
        opener.addEventListener('click', revealFilm);
      });

      if (filmReset) {
        filmReset.addEventListener('click', resetFilm);
      }

      if (filmPlayer) {
        filmPlayer.addEventListener('click', function(event) {
          if (event.target === filmPlayer) resetFilm();
        });
        document.addEventListener('keydown', handleFilmKeydown);
      }

      function filterFaq() {
        var term = search ? search.value.trim().toLowerCase() : '';
        var visibleCount = 0;

        items.forEach(function(item) {
          var text = item.innerText.toLowerCase();
          var isVisible = !term || text.indexOf(term) !== -1;
          item.classList.toggle('is-hidden', !isVisible);
          if (isVisible) visibleCount += 1;
        });

        if (empty) empty.hidden = visibleCount > 0;
      }

      if (search) {
        search.addEventListener('input', filterFaq);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApprovedHomeV4);
  } else {
    initApprovedHomeV4();
  }

  document.addEventListener('shopify:section:load', initApprovedHomeV4);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-launch-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-home-launch-v4]');
    if (!root) return;

    const model = root.querySelector('model-viewer');
    const viewButtons = root.querySelectorAll('[data-view-orbit]');
    const spinToggle = root.querySelector('[data-spin-toggle]');
    if (model) model.removeAttribute('auto-rotate');

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const orbit = button.getAttribute('data-view-orbit');
        if (model && orbit) model.setAttribute('camera-orbit', orbit);
        viewButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
      });
    });

    if (spinToggle && model) {
      spinToggle.addEventListener('click', () => {
        const shouldSpin = !model.hasAttribute('auto-rotate');
        model.toggleAttribute('auto-rotate', shouldSpin);
        spinToggle.classList.toggle('is-active', shouldSpin);
        spinToggle.setAttribute('aria-pressed', shouldSpin ? 'true' : 'false');
        spinToggle.textContent = shouldSpin ? 'Stop spin' : 'Spin';
      });
    }

    const tabButtons = root.querySelectorAll('[data-tab-trigger]');
    const tabPanels = root.querySelectorAll('[data-tab-panel]');
    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.getAttribute('data-tab-trigger');
        tabButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach((panel) => {
          const isActive = panel.getAttribute('data-tab-panel') === key;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
      });
    });

    const search = root.querySelector('[data-faq-search]');
    const faqItems = root.querySelectorAll('[data-faq-item]');
    if (search) {
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        faqItems.forEach((item) => {
          const matches = item.textContent.toLowerCase().includes(query);
          item.classList.toggle('is-hidden', query.length > 0 && !matches);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-reference"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-article-reference]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    root.querySelectorAll('[aria-hidden="true"]').forEach((element) => {
      if (element.textContent.trim().startsWith('\u00e2')) element.textContent = '\u2197';
    });
    root.querySelectorAll('span').forEach((element) => {
      if (element.textContent.trim() === '\u00c2\u00b7') element.textContent = '\u00b7';
    });
    const momentPrompt = root.querySelector('#chapter-moment strong');
    if (momentPrompt) momentPrompt.textContent = '\u201C I want the viewer to feel or understand...\u201D';
    const careIcon = root.querySelector('.article-reference-care-callout__icon');
    if (careIcon) careIcon.textContent = '\u2022';

    const progress = root.querySelector('[data-article-progress]');
    const body = root.querySelector('.eight-article-reference__body');
    const shareButton = root.querySelector('[data-article-share]');
    const label = root.querySelector('[data-share-label]');
    const status = root.querySelector('[data-share-status]');
    const originalLabel = label ? label.textContent : 'Share story';
    let progressFrame = null;

    const updateProgress = () => {
      progressFrame = null;
      if (!progress || !body) return;
      const bodyTop = body.getBoundingClientRect().top + window.scrollY;
      const scrollable = Math.max(1, body.offsetHeight - window.innerHeight);
      const ratio = Math.min(1, Math.max(0, (window.scrollY - bodyTop + window.innerHeight * 0.35) / scrollable));
      progress.style.width = `${ratio * 100}%`;
    };

    const onScroll = () => {
      if (progressFrame === null) progressFrame = window.requestAnimationFrame(updateProgress);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateProgress();

    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        const shareData = { title: shareButton.dataset.shareTitle || document.title, url: window.location.href };
        try {
          if (navigator.share) {
            await navigator.share(shareData);
          } else {
            await navigator.clipboard.writeText(window.location.href);
            if (label) label.textContent = 'Link copied';
            if (status) status.textContent = 'Article link copied to clipboard.';
            window.setTimeout(() => {
              if (label) label.textContent = originalLabel;
              if (status) status.textContent = '';
            }, 2200);
          }
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          if (status) status.textContent = 'Copy the link from your browser to share this story.';
        }
      });
    }

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target && event.target.contains(root)) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        if (progressFrame !== null) window.cancelAnimationFrame(progressFrame);
      }
    }, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-team"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-staging-share]').forEach((button) => {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      const status = button.parentElement.querySelector('[data-staging-share-status]');
      button.addEventListener('click', async () => {
        try {
          if (navigator.share) {
            await navigator.share({ title: document.title, url: window.location.href });
          } else {
            await navigator.clipboard.writeText(window.location.href);
            if (status) status.textContent = 'Link copied';
          }
        } catch (error) {
          if (error && error.name !== 'AbortError' && status) status.textContent = 'Copy the link from your browser';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const buttons = document.querySelectorAll('[data-story-share]');

    buttons.forEach((button) => {
      if (button.dataset.shareReady === 'true') return;
      button.dataset.shareReady = 'true';

      const label = button.querySelector('[data-share-label]');
      const status = button.parentElement.querySelector('[data-share-status]');
      const originalLabel = label ? label.textContent : 'Share';

      const copyLink = async () => {
        await navigator.clipboard.writeText(window.location.href);
        if (label) label.textContent = 'Link copied';
        if (status) status.textContent = 'Article link copied to clipboard.';
        window.setTimeout(() => {
          if (label) label.textContent = originalLabel;
          if (status) status.textContent = '';
        }, 2200);
      };

      button.addEventListener('click', async () => {
        const shareData = {
          title: button.dataset.shareTitle || document.title,
          url: window.location.href,
        };

        try {
          if (navigator.share) {
            await navigator.share(shareData);
          } else {
            await copyLink();
          }
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          try {
            await copyLink();
          } catch (copyError) {
            if (status) status.textContent = 'Copy the link from your browser to share this story.';
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-addresses-8ight"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-customer-addresses]');
    if (!root) return;

    root.querySelectorAll('[data-close-address]').forEach((button) => {
      button.addEventListener('click', () => {
        const details = button.closest('details');
        if (details) details.open = false;
      });
    });

    root.querySelectorAll('[data-delete-address]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        if (!window.confirm(root.dataset.deleteConfirm)) event.preventDefault();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-auth-8ight"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-customer-auth]');
    if (!root || root.dataset.authMode !== 'login') return;

    const login = root.querySelector('[data-login-panel]');
    const recovery = root.querySelector('[data-recovery-panel]');
    const show = root.querySelector('[data-show-recovery]');
    const hide = root.querySelector('[data-hide-recovery]');

    const setRecovery = (visible) => {
      login.hidden = visible;
      recovery.hidden = !visible;
      if (visible) recovery.querySelector('input')?.focus();
      else login.querySelector('input')?.focus();
    };

    show?.addEventListener('click', () => setRecovery(true));
    hide?.addEventListener('click', () => setRecovery(false));

    if (window.location.hash === '#recover' || document.documentElement.dataset.recoverSuccess === 'true') {
      setRecovery(true);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-section"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Video handling
    const video = document.querySelector('.media-section__video');
    const poster = document.querySelector('.media-section__poster');
    
    if (video) {
      // Respect reduced motion preference
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        // Keep poster visible, don't play video
        return;
      }

      let videoReady = false;
      const fadeInVideo = function() {
        if (videoReady) return;
        videoReady = true;
        video.classList.add('ready');
        if (poster) {
          poster.classList.add('hidden');
        }
      };

      // Try canplaythrough first for smoother playback
      video.addEventListener('canplaythrough', fadeInVideo, { once: true });
      
      // Fallback to canplay if canplaythrough doesn't fire quickly
      video.addEventListener('canplay', function() {
        setTimeout(function() {
          if (!videoReady) {
            fadeInVideo();
          }
        }, 500);
      }, { once: true });

      // Handle errors - keep poster visible
      video.addEventListener('error', function() {
        if (poster) {
          poster.classList.remove('hidden');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about-launch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-about-human]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach((section) => {
      if (section.dataset.aboutReady === 'true') return;
      section.dataset.aboutReady = 'true';
      section.classList.add('is-enhanced');

      const revealItems = section.querySelectorAll('[data-about-reveal]');
      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

      revealItems.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-affiliate-program"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const activeItem = event.target;
    if (!(activeItem instanceof HTMLDetailsElement) || !activeItem.open || !activeItem.closest('.affiliate-program__faq-list')) return;
    activeItem.closest('.affiliate-program__faq-list').querySelectorAll('details[open]').forEach((item) => {
      if (item !== activeItem) item.removeAttribute('open');
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ambassador-selective"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const activeItem = event.target;
    if (!(activeItem instanceof HTMLDetailsElement) || !activeItem.open || !activeItem.closest('.ambassador-selective__faq-list')) return;
    activeItem.closest('.ambassador-selective__faq-list').querySelectorAll('details[open]').forEach((item) => {
      if (item !== activeItem) item.removeAttribute('open');
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-app-studio"] && !Shopify.designMode) return;
  try {
    
  (function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'page_view', page: 'app_studio' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-cinema-tik-grant"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cinema-tik-grant]').forEach((section) => {
      const tabs = [...section.querySelectorAll('[data-criterion-tab]')];
      const panels = [...section.querySelectorAll('[data-criterion-panel]')];
      const media = [...section.querySelectorAll('[data-criterion-media]')];

      const selectCriterion = (tab, shouldFocus = false) => {
        const target = tab.dataset.target;

        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          const active = panel.dataset.criterionPanel === target;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        media.forEach((item) => {
          const active = item.dataset.criterionMedia === target;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
        });

        if (shouldFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectCriterion(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          selectCriterion(tabs[nextIndex], true);
        });
      });

      const faqItems = [...section.querySelectorAll('.cinema-tik__faq-item')];
      faqItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open || !window.matchMedia('(max-width: 749px)').matches) return;
          faqItems.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.contact-hub');

    sections.forEach((section) => {
      const select = section.querySelector('select[name="contact[topic]"]');
      const buttons = section.querySelectorAll('.contact-hub__topic-button');

      if (!select || !buttons.length) return;

      const requestedTopic = new URLSearchParams(window.location.search).get('topic');
      const matchingOption = [...select.options].find((option) => option.value.toLowerCase() === (requestedTopic || '').toLowerCase());

      if (!select.value && matchingOption) {
        select.value = matchingOption.value;
      } else if (!select.value) {
        select.value = 'Support';
      }

      const updateButtons = () => {
        buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.topic === select.value));
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          select.value = button.dataset.topic || '';
          select.dispatchEvent(new Event('change', { bubbles: true }));
          select.focus({ preventScroll: true });
        });
      });

      select.addEventListener('change', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-eight-studio-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-studio-premium]').forEach((section) => {
      const tabs = Array.from(section.querySelectorAll('[data-studio-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-studio-panel]'));
      const playButton = section.querySelector('[data-studio-play]');
      const playLabel = section.querySelector('[data-studio-play-label]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let timer = null;

      const setPlayingState = (playing) => {
        if (!playButton || !playLabel) return;
        playButton.classList.toggle('is-playing', playing);
        playButton.setAttribute('aria-label', playing ? 'Pause the Studio workflow' : 'Play the Studio workflow');
        playLabel.textContent = playing ? 'Pause workflow' : 'Play workflow';
      };

      const stopPlayback = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
        setPlayingState(false);
      };

      const activate = (index, moveFocus = false) => {
        activeIndex = index;

        tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === activeIndex;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== activeIndex;
        });

        if (moveFocus) tabs[activeIndex].focus();
      };

      const startPlayback = () => {
        if (reducedMotion || tabs.length < 2) return;
        if (timer) return;
        setPlayingState(true);
        timer = window.setInterval(() => {
          activate((activeIndex + 1) % tabs.length);
        }, 3200);
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          stopPlayback();
          activate(index);
        });

        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          stopPlayback();

          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activate(nextIndex, true);
        });
      });

      if (playButton) {
        if (reducedMotion) {
          playButton.hidden = true;
        } else {
          playButton.addEventListener('click', () => {
            if (timer) stopPlayback();
            else startPlayback();
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-livestream-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.livePremiumReady === 'true') return;
      section.dataset.livePremiumReady = 'true';

      const bindTabs = (tabSelector, panelSelector) => {
        const tabs = Array.from(section.querySelectorAll(tabSelector));
        const panels = Array.from(section.querySelectorAll(panelSelector));
        if (!tabs.length || !panels.length) return;

        const activate = (tab, moveFocus = false) => {
          const key = tab.dataset.liveTab || tab.dataset.scenarioTab;
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            const panelKey = panel.dataset.livePanel || panel.dataset.scenarioPanel;
            panel.hidden = panelKey !== key;
          });
          if (moveFocus) tab.focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', (event) => {
            let nextIndex = null;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (nextIndex === null) return;
            event.preventDefault();
            activate(tabs[nextIndex], true);
          });
        });
      };

      bindTabs('[data-live-tab]', '[data-live-panel]');
      bindTabs('[data-scenario-tab]', '[data-scenario-panel]');

      const faqItems = Array.from(section.querySelectorAll('.live-premium__faq-item'));
      faqItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open || window.matchMedia('(min-width: 990px)').matches) return;
          faqItems.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    };

    document.querySelectorAll('[data-live-premium]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-live-premium]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-product-primary"] && !Shopify.designMode) return;
  try {
    
  (function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'product_view', page: 'product_primary' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-responsible-use-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-responsible-v4]').forEach((root) => {
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const activate = (tab) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = root.querySelector(`#${item.getAttribute('aria-controls')}`);
          if (panel) panel.hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next]); tabs[next].focus();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-returns-care"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-returns-care]');

    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

      const activateTab = (tab, moveFocus = false) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          const selected = panel.id === tab.getAttribute('aria-controls');
          panel.hidden = !selected;
          panel.classList.toggle('is-entering', selected);
          if (selected) window.setTimeout(() => panel.classList.remove('is-entering'), 240);
        });

        if (moveFocus) tab.focus();
        const path = tab.dataset.path;
        if (path && window.history && window.history.replaceState) {
          window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${path}`);
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        });
      });

      const requestedPath = window.location.hash.replace('#', '');
      const requestedTab = tabs.find((tab) => tab.dataset.path === requestedPath);
      if (requestedTab) activateTab(requestedTab);

      const faqItems = Array.from(root.querySelectorAll('.returns-care__faq-list details'));
      faqItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open || !window.matchMedia('(max-width: 680px)').matches) return;
          faqItems.forEach((other) => { if (other !== item) other.open = false; });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-size-fit-before-experience-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-size-fit]').forEach((section) => {
      const tabs = Array.from(section.querySelectorAll('[data-fit-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-fit-panel]'));
      const form = section.querySelector('[data-fit-form]');
      const summary = section.querySelector('[data-fit-summary]');
      const feelButtons = Array.from(section.querySelectorAll('[data-fit-feel]'));
      let selectedFeel = 'right';

      const activateTab = (index, moveFocus = false) => {
        tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });

        if (moveFocus) tabs[index].focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activateTab(nextIndex, true);
        });
      });

      if (!form || !summary) return;

      const inputs = Array.from(form.querySelectorAll('input[type="number"]'));
      const feelCopy = {
        tight: 'Your current pair feels tight. The modular hinge is designed to add temple clearance, but do not assume compatibility yet. Compare these measurements with the final supported fit range before ordering or contact the team.',
        right: 'Your current pair feels right. Use these measurements as your baseline. The modular hinge adds temple clearance, but the final production chart remains the fit reference before ordering.',
        loose: 'Your current pair feels loose. Additional hinge clearance will not correct a frame that is already loose. Compare these measurements with the final frame and bridge guidance before ordering.'
      };

      const updateSummary = () => {
        const labels = {
          frame_width: 'frame width',
          bridge: 'bridge',
          temple: 'temple'
        };
        const values = inputs
          .filter((input) => input.value !== '')
          .map((input) => `${labels[input.name]} ${input.value} mm`);

        if (!values.length) {
          summary.textContent = 'Add the numbers from your current frame. They stay on this page and are not submitted.';
          return;
        }

        summary.textContent = `Reference pair: ${values.join(', ')}. ${feelCopy[selectedFeel]}`;
      };

      inputs.forEach((input) => input.addEventListener('input', updateSummary));

      feelButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedFeel = button.dataset.fitFeel;
          feelButtons.forEach((item) => item.setAttribute('aria-checked', item === button ? 'true' : 'false'));
          updateSummary();
        });

        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const currentIndex = feelButtons.indexOf(button);
          const nextIndex = event.key === 'ArrowRight'
            ? (currentIndex + 1) % feelButtons.length
            : (currentIndex - 1 + feelButtons.length) % feelButtons.length;
          feelButtons[nextIndex].click();
          feelButtons[nextIndex].focus();
        });
      });

      form.addEventListener('submit', (event) => event.preventDefault());
      form.addEventListener('reset', () => {
        window.setTimeout(() => {
          selectedFeel = 'right';
          feelButtons.forEach((item) => item.setAttribute('aria-checked', item.dataset.fitFeel === 'right' ? 'true' : 'false'));
          updateSummary();
        }, 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-size-fit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-size-fit]').forEach((section) => {
      const tabs = Array.from(section.querySelectorAll('[data-fit-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-fit-panel]'));
      const form = section.querySelector('[data-fit-form]');
      const summary = section.querySelector('[data-fit-summary]');
      const feelButtons = Array.from(section.querySelectorAll('[data-fit-feel]'));
      let selectedFeel = 'right';

      const activateTab = (index, moveFocus = false) => {
        tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });

        if (moveFocus) tabs[index].focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activateTab(nextIndex, true);
        });
      });

      if (!form || !summary) return;

      const inputs = Array.from(form.querySelectorAll('input[type="number"]'));
      const feelCopy = {
        tight: 'Your current pair feels tight. The modular hinge is designed to add temple clearance, but do not assume compatibility yet. Compare these measurements with the final supported fit range before ordering or contact the team.',
        right: 'Your current pair feels right. Use these measurements as your baseline. The modular hinge adds temple clearance, but the final production chart remains the fit reference before ordering.',
        loose: 'Your current pair feels loose. Additional hinge clearance will not correct a frame that is already loose. Compare these measurements with the final frame and bridge guidance before ordering.'
      };

      const updateSummary = () => {
        const labels = {
          frame_width: 'frame width',
          bridge: 'bridge',
          temple: 'temple'
        };
        const values = inputs
          .filter((input) => input.value !== '')
          .map((input) => `${labels[input.name]} ${input.value} mm`);

        if (!values.length) {
          summary.textContent = 'Add the numbers from your current frame. They stay on this page and are not submitted.';
          return;
        }

        summary.textContent = `Reference pair: ${values.join(', ')}. ${feelCopy[selectedFeel]}`;
      };

      inputs.forEach((input) => input.addEventListener('input', updateSummary));

      feelButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedFeel = button.dataset.fitFeel;
          feelButtons.forEach((item) => item.setAttribute('aria-checked', item === button ? 'true' : 'false'));
          updateSummary();
        });

        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const currentIndex = feelButtons.indexOf(button);
          const nextIndex = event.key === 'ArrowRight'
            ? (currentIndex + 1) % feelButtons.length
            : (currentIndex - 1 + feelButtons.length) % feelButtons.length;
          feelButtons[nextIndex].click();
          feelButtons[nextIndex].focus();
        });
      });

      form.addEventListener('submit', (event) => event.preventDefault());
      form.addEventListener('reset', () => {
        window.setTimeout(() => {
          selectedFeel = 'right';
          feelButtons.forEach((item) => item.setAttribute('aria-checked', item.dataset.fitFeel === 'right' ? 'true' : 'false'));
          updateSummary();
        }, 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-stories-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-stories-v4]').forEach((root) => {
      const buttons = root.querySelectorAll('[data-story-filter]');
      const stories = root.querySelectorAll('[data-story-category]');
      buttons.forEach((button) => button.addEventListener('click', () => {
        const filter = button.dataset.storyFilter;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        stories.forEach((story) => { story.hidden = filter !== 'all' && story.dataset.storyCategory !== filter; });
      }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-use-cases"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-use-cases-section]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    sections.forEach((section) => {
      const nav = section.querySelector('[data-chapter-nav]');
      const scroll = section.querySelector('[data-chapter-scroll]');
      const links = Array.from(section.querySelectorAll('[data-chapter-link]'));
      const chapters = Array.from(section.querySelectorAll('[data-chapter]'));
      if (!nav || !scroll || !links.length || !chapters.length) return;

      const setActive = (id) => {
        links.forEach((link) => {
          const isActive = link.getAttribute('href') === `#${id}`;
          link.classList.toggle('is-active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'location');
            const targetLeft = link.offsetLeft - (scroll.clientWidth - link.offsetWidth) / 2;
            scroll.scrollTo({ left: Math.max(0, targetLeft), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
          } else {
            link.removeAttribute('aria-current');
          }
        });
      };

      links.forEach((link, index) => {
        link.addEventListener('click', (event) => {
          const target = section.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
          setActive(target.id);
          history.replaceState(null, '', `#${target.id}`);
        });

        link.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % links.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + links.length) % links.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = links.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          links[nextIndex].focus();
        });
      });

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      }, { rootMargin: '-28% 0px -58% 0px', threshold: [0.05, 0.2, 0.45] });

      chapters.forEach((chapter) => observer.observe(chapter));

      const initialId = window.location.hash.slice(1);
      if (initialId && chapters.some((chapter) => chapter.id === initialId)) setActive(initialId);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const chapter = document.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (chapter) chapter.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-waitlist"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initReveal(section) {
      var items = Array.prototype.slice.call(section.querySelectorAll('[data-waitlist-reveal]'));
      if (!items.length) return;

      if (reduceMotion.matches || !('IntersectionObserver' in window)) {
        items.forEach(function(item) { item.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8%', threshold: 0.12 });

      items.forEach(function(item) { observer.observe(item); });
    }

    function initWaitlist(section) {
      if (!section || section.dataset.waitlistReady === 'true') return;
      section.dataset.waitlistReady = 'true';
      initReveal(section);

      var form = section.querySelector('.waitlist-v5__form');
      if (!form) return;

      var title = section.querySelector('.waitlist-v5__signup-heading h2');
      if (title && title.id) form.setAttribute('aria-labelledby', title.id);

      var email = form.querySelector('input[type="email"]');
      var consent = form.querySelector('input[type="checkbox"]');
      var fields = form.querySelector('[data-waitlist-fields]');
      var success = form.querySelector('[data-waitlist-success]');
      var emailError = form.querySelector('[data-waitlist-email-error]');
      var consentError = form.querySelector('[data-waitlist-consent-error]');
      var serverError = form.querySelector('[data-waitlist-server-error]');
      var submit = form.querySelector('[data-waitlist-submit]');
      var label = form.querySelector('[data-submit-label]');
      var loading = form.querySelector('[data-submit-loading]');
      var status = form.querySelector('[data-waitlist-status]');
      var tags = form.querySelector('[data-waitlist-tags]');
      var returnLink = section.querySelector('[data-waitlist-return]');

      function setFieldError(input, target, message) {
        if (!input || !target) return;
        if (message) {
          input.setAttribute('aria-invalid', 'true');
          if (target.textContent !== message) target.textContent = message;
          if (target.hidden) target.hidden = false;
        } else {
          input.removeAttribute('aria-invalid');
          if (target.textContent) target.textContent = '';
          if (!target.hidden) target.hidden = true;
        }
      }

      function clearServerError() {
        if (!serverError) return;
        serverError.textContent = '';
        serverError.hidden = true;
      }

      function showServerError(message) {
        if (!serverError) return;
        serverError.textContent = message;
        serverError.hidden = false;
        serverError.focus({ preventScroll: true });
      }

      function setLoading(isLoading) {
        if (submit) {
          submit.disabled = isLoading;
          if (isLoading) submit.setAttribute('aria-busy', 'true');
          else submit.removeAttribute('aria-busy');
        }
        if (label) label.hidden = isLoading;
        if (loading) loading.hidden = !isLoading;
        if (status) status.textContent = isLoading ? 'Submitting your waitlist request.' : '';
      }

      function validateEmail(showError) {
        if (!email) return false;
        var value = email.value.trim();
        if (email.value !== value) email.value = value;
        var isValid = Boolean(value && email.validity.valid);

        if (showError) {
          setFieldError(
            email,
            emailError,
            isValid ? '' : (section.dataset.invalidEmail || 'Enter a valid email address.')
          );
        }

        return isValid;
      }

      var params = new URLSearchParams(window.location.search);
      var utmSource = params.get('utm_source');
      if (tags && utmSource && tags.value.indexOf('utm_') === -1) {
        var safeSource = utmSource.toLowerCase().replace(/[^a-z0-9_-]+/g, '_').slice(0, 40);
        if (safeSource) tags.value += ', utm_' + safeSource;
      }

      if (success && !success.hidden) {
        window.requestAnimationFrame(function() { success.focus({ preventScroll: true }); });
      }

      if (email) {
        email.addEventListener('input', function() {
          if (email.hasAttribute('aria-invalid') && email.value.trim() && email.validity.valid) {
            setFieldError(email, emailError, '');
          }
          clearServerError();
        });

        email.addEventListener('blur', function() {
          if (email.value.trim()) validateEmail(true);
        });
      }

      if (consent) {
        consent.addEventListener('change', function() {
          setFieldError(consent, consentError, '');
          clearServerError();
        });
      }

      form.addEventListener('submit', function(event) {
        event.preventDefault();
        setFieldError(email, emailError, '');
        setFieldError(consent, consentError, '');
        clearServerError();

        var emailIsValid = validateEmail(true);
        var consentIsValid = Boolean(consent && consent.checked);

        if (!consentIsValid) {
          setFieldError(consent, consentError, section.dataset.invalidConsent || 'Confirm that you agree to receive launch updates.');
        }

        if (!emailIsValid || !consentIsValid) {
          if (!emailIsValid && email) email.focus();
          else if (consent) consent.focus();
          return;
        }

        setLoading(true);

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        })
          .then(function(response) {
            if (response.url.indexOf('/challenge') !== -1) {
              window.location.assign(response.url);
              return null;
            }
            return response.text().then(function(html) {
              return { response: response, html: html };
            });
          })
          .then(function(result) {
            if (!result) return;
            var returnedDocument = new DOMParser().parseFromString(result.html, 'text/html');
            var returnedForm = form.id ? returnedDocument.getElementById(form.id) : null;
            var returnedSuccess = returnedForm && returnedForm.querySelector('[data-waitlist-success]:not([hidden])');
            var returnedError = returnedForm && returnedForm.querySelector('[data-waitlist-server-error]');

            if (!result.response.ok || !returnedSuccess) {
              var safeMessage = returnedError && returnedError.textContent.trim();
              var signupError = new Error(safeMessage || section.dataset.submitError || 'We could not add you right now. Please try again.');
              signupError.name = 'WaitlistSignupError';
              throw signupError;
            }

            if (fields) fields.hidden = true;
            if (success) {
              success.hidden = false;
              success.focus({ preventScroll: true });
            }
            setLoading(false);
            if (status) status.textContent = 'You are on the 8ight Pro waitlist.';
          })
          .catch(function(error) {
            var message = error && error.message ? error.message : (section.dataset.submitError || 'We could not add you right now. Please try again.');
            showServerError(message);
            setLoading(false);
          });
      });
      form.noValidate = true;

      if (returnLink) {
        returnLink.addEventListener('click', function(event) {
          event.preventDefault();
          var target = success && !success.hidden ? success : email;
          if (!target) return;
          target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
          window.setTimeout(function() {
            target.focus({ preventScroll: true });
          }, reduceMotion.matches ? 0 : 420);
        });
      }
    }

    function initAll(root) {
      if (root && root.matches && root.matches('[data-waitlist-page]')) initWaitlist(root);
      if (root && root.querySelectorAll) {
        root.querySelectorAll('[data-waitlist-page]').forEach(initWaitlist);
      }
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function setReady(section) {
      section.classList.add('product-gallery-section--is-ready');
    }

    function setError(section) {
      section.classList.add('product-gallery-section--model-error');
      setReady(section);
    }

    function initSection(section) {
      if (section.dataset.viewerReady === 'true') {
        return;
      }

      section.dataset.viewerReady = 'true';
      var model = section.querySelector('model-viewer');
      var controls = section.querySelectorAll('[data-camera-orbit]');

      if (!model) {
        setReady(section);
        return;
      }

      model.addEventListener('load', function() {
        setReady(section);
      });

      model.addEventListener('error', function() {
        setError(section);
      });

      setTimeout(function() {
        if (!section.classList.contains('product-gallery-section--is-ready')) {
          setReady(section);
        }
      }, 5200);

      controls.forEach(function(control) {
        control.addEventListener('click', function() {
          var orbit = control.getAttribute('data-camera-orbit');

          if (orbit) {
            model.setAttribute('camera-orbit', orbit);
          }

          controls.forEach(function(item) {
            item.classList.remove('product-gallery-section__control--active');
            item.setAttribute('aria-pressed', 'false');
          });

          control.classList.add('product-gallery-section__control--active');
          control.setAttribute('aria-pressed', 'true');
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-product-viewer]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('[data-product-viewer]');
      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-purchase-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const colorOptions = document.querySelectorAll('.product-purchase-form__color-option');
    const sizeOptions = document.querySelectorAll('.product-purchase-form__size-option');
    const colorDetails = document.querySelector('.product-purchase-form__color-details');
    const sizeDetails = document.querySelector('.product-purchase-form__size-details');

    // Handle color selection
    colorOptions.forEach(option => {
      option.addEventListener('click', function() {
        const colorName = this.getAttribute('data-color');
        
        // Update active state
        colorOptions.forEach(opt => opt.classList.remove('product-purchase-form__color-option--active'));
        this.classList.add('product-purchase-form__color-option--active');

        // Update color details if available
        // This would need to be populated from block settings
      });
    });

    // Handle size selection
    sizeOptions.forEach(option => {
      option.addEventListener('click', function() {
        const sizeName = this.getAttribute('data-size');
        
        // Update active state
        sizeOptions.forEach(opt => opt.classList.remove('product-purchase-form__size-option--active'));
        this.classList.add('product-purchase-form__size-option--active');

        // Update size details if available
        // This would need to be populated from block settings
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const video = document.querySelector('.video-section__video');
    const poster = document.querySelector('.video-section__poster');
    
    if (!video) return;

    // Respect reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      // Keep poster visible, don't play video
      return;
    }

    let videoReady = false;
    const fadeInVideo = function() {
      if (videoReady) return;
      videoReady = true;
      video.classList.add('ready');
      if (poster) {
        poster.classList.add('hidden');
      }
    };

    // Try canplaythrough first for smoother playback
    video.addEventListener('canplaythrough', fadeInVideo, { once: true });
    
    // Fallback to canplay if canplaythrough doesn't fire quickly
    video.addEventListener('canplay', function() {
      setTimeout(function() {
        if (!videoReady) {
          fadeInVideo();
        }
      }, 500);
    }, { once: true });

    // Handle errors - keep poster visible
    video.addEventListener('error', function() {
      if (poster) {
        poster.classList.remove('hidden');
      }
    });

    // Ensure video plays when user interacts (for autoplay policies)
    video.addEventListener('click', function() {
      if (video.paused) {
        video.play().catch(function() {
          // Autoplay was prevented, user will need to click play button
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
